const About = () => {
  return (
    <div className="max-w-3xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
        About GeoForge3D
      </h1>
      <p className="text-gray-600 mb-4">
        GeoForge3D creates custom 3D map art pieces from real geographic data. Each piece is uniquely
        generated using Digital Elevation Model data and OpenStreetMap information to produce stunning,
        accurate representations of your favorite places.
      </p>
      <p className="text-gray-600">
        Our mission is to help you preserve and display the places that matter most to you in a beautiful,
        tangible form.
      </p>
    </div>
  );
};

export default About;
